/**
 * The rule for what counts as an embed type, written once for the Validate page
 * (`embedsOf` in `pages/validate/embeds.ts`) and the server (`embedsFrom` in
 * `bobcat/src/server-only/ai/router.ts`). This module has no imports so it loads under
 * jsdom and in the server bundle alike.
 *
 * The server calls `normalizeEmbedType` on untrusted input from the wire, so
 * the rule is checked again there and does not depend on the page having run it.
 *
 * Not done here, and left to each caller: dropping repeats, the page's
 * `NOT_AN_EMBED` exclusions and its skip of frames with `options`, and the
 * `MAX_EMBEDS` ceiling (this module only exports the number).
 */

/** The most embed types one turn keeps. Applied by the callers. */
export const MAX_EMBEDS = 10;

const MAX_TYPE_LENGTH = 40;

/** The alphabet an embed type may use: lower-case letters, digits, `_`, `-`. */
export const EMBED_TYPE_PATTERN = /^[a-z0-9_-]+$/;

/**
 * Trims, lower-cases and cuts `raw` to 40 characters; returns the result only
 * if all of it matches `EMBED_TYPE_PATTERN`, else `null`.
 */
export const normalizeEmbedType = (raw: string): string | null => {
  const type = raw.trim().toLowerCase().slice(0, MAX_TYPE_LENGTH);
  return EMBED_TYPE_PATTERN.test(type) ? type : null;
};
